export const requiredDocumentInstructions =
  'Your agency may require that winning vendors submit certain documents as part of or after winning the bid. You can add those document requirements and assign due dates here. You may assign a default due date for everything, or set custom ones for different documents.';
